import React, { useState, useEffect,useCallback } from 'react';
import {
    Form,Button, Select,Drawer, Row,Col, Input
} from 'antd';
import {useSelector, useDispatch} from 'react-redux'
import { connect } from 'react-redux'
import { Field, FormSection, reduxForm } from 'redux-form'
import { actionAddProduct, actionEditProduct, closeEditProductModal, closeNewProductModal } from '../../../store/acciones/accionesProductos';
import { InputField, required, FieldSelectNormalEditar,textArea,InputTypePrice } from '../../app/inputs/InputField';
import ImageUpload from '../widgets/ImageUpload';
import FileUpload from '../widgets/FileUpload';
import ImageUploadVersionDos from '../widgets/ImageUploadV2';

  const data = {
    id_producto: null,
    Nombre: null,
    Precio1: null,
    Rango1: null,
    Precio2: null,
    Rango2: null,
    medida: null,
    IdMaterial: null,

    id: null,
    descripcion_producto: null,
    image_product: null,
    file_product: null,
    date_hight: null,
    date_modify: null,
    status: true,
    producto:null
  }

let  ProductModalForm = (props) => {
    const dispatch=useDispatch()
    let productModal = useSelector(state => state.reducerProductos.productModal);
    let usuario =useSelector(state=>state.reducerUsuario.usuario)

  function closeComposeDialog() {
    return productModal.type === 'edit'
      ? dispatch(closeEditProductModal())
      : dispatch(closeNewProductModal());
  }

 
  function handleSubmit(values) {
    if (productModal.type === 'new') {
      dispatch(actionAddProduct(values))
    } 
    else {
      if (productModal.data) {
        let idInfoProduct=productModal.data.info_product && productModal.data.info_product.id?productModal.data.info_product.id:null
        dispatch(actionEditProduct(values, productModal.data.id, idInfoProduct ))
      }
			 
		}
		closeComposeDialog();
  } 
 
  
    return (
        <Drawer
            title="Form Productos"
            placement="right"
            // closable={false}
            onClose={closeComposeDialog}
            {...productModal.props}
            width={500}
            destroyOnClose
        >
        <Form onSubmit={props.handleSubmit(handleSubmit)} layout="horizontal" >
          {usuario.is_superuser && <>
            <Field name="clave_producto" component={InputField} ph="Clave del producto" validate={[required]} />
            <Field name="nombre_producto" component={InputField} ph="Nombre del producto" validate={[required]} />
            <Field name="descripcion_producto" component={textArea} ph="Descripcion del producto" />
            <Field name="medida_producto" component={InputField} ph="Medida del producto" validate={[required]} />
            <Row type="flex" justify="start" align="top" style={{ flexDirection: "column" }}>
              <Col xl={24} lg={24} md={24} sm={24} xs={24} >
                <Row type="flex" justify="space-around" align="middle">
                  <Col sm={24} xs={24} >
                    <p style={{ fontWeight: "bold", fontSize: "20px" }}>Precio Venta</p>
                  </Col>
                  <Col xl={10} lg={10} md={10} sm={24} xs={24} >
                    <Field name="precio_publico" component={InputTypePrice} ph="Precio Publico" parse={value => !value ? null : Number(value)} validate={[required]} />
                  </Col>
                </Row>
              </Col>
            </Row>

          </>}
          
          {productModal.type === 'edit' && (
            <div className="flex flex-row align-middle">
              <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", marginTop: 20, marginBottom: 20 }}>
                {usuario.is_superuser?  <ImageUploadVersionDos files={props.initialValues} product={props.initialValues}/>:
                <ImageUploadVersionDos files={props.initialValues} product={props.initialValues}/>}
              </div>
            </div>
          )}
          {/* <Field name="image_product" component={InputField} ph="Image product" validate={[required]} /> */}
       

          <Form.Item>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Button loading={props.loading} type="primary" htmlType="submit" className="loginFormButton">
                Guardar
              </Button>
            </div>
          </Form.Item>
        </Form>
        </Drawer>
    );
};

ProductModalForm = reduxForm({
    form: 'ProductModalForm',
    enableReinitialize: true,
  })(ProductModalForm)

  ProductModalForm = connect(
    state => ({
      initialValues: state.reducerProductos.productModal.data 
    })
    //{ load: loadAccount } 
  )(ProductModalForm)
  
  export default ProductModalForm